import { ProfilePage } from "components/ProfilePage"
import { ReviewCard } from "components/ReviewCard"
import { useTranslator } from "components/Translator"
import { Tabs, TabList, Tab } from "components/Tab"
import { Text } from "components/Text"
import { Pagination } from "components/Pagination"
import {useConnectedUser} from "components/ConnectedUserProvider";

export function AccountReviewIndexPage({
  user,
  infos,
  reviews,
  target,
  pagination,
  tabs: layoutTabs = window.accountNav,
}) {
  const translator = useTranslator()
  const connectedUser = useConnectedUser()

  let tabs = [
    {
      label: translator.trans("account.review.index.received", null, "pages"),
      id: "received",
      href: `/${translator.locale}/account/${user.id}/reviews/`,
      isCurrent: target === "received",
    },
    {
      label: translator.trans("account.review.index.given", null, "pages"),
      id: "given",
      href: `/${translator.locale}/account/${user.id}/reviews/given`,
      isCurrent: target === "given",
    },
  ]

  if (connectedUser.id === user.id) {
    tabs = tabs.concat({
      label: translator.trans("account.review.index.draft", null, "pages"),
      id: "draft",
      href: `/${translator.locale}/account/${user.id}/reviews/draft`,
      isCurrent: target === "draft",
    })
  }

  return (
    <ProfilePage user={user} tabs={layoutTabs} infos={infos}>
      <div className="space-y-6">
        <div className="flex flex-row justify-center">
          <Tabs
            currentPanel={tabs.find((tab) => tab.isCurrent).id}
            onChange={() => null}
          >
            <TabList>
              {tabs.map((tab) => (
                <Tab
                  key={tab.label}
                  label={tab.label}
                  id={tab.id}
                  href={tab.href}
                />
              ))}
            </TabList>
          </Tabs>
        </div>
        <div className="space-y-6">
          {reviews.length > 0 ? (
            reviews.map((review) => {
              return (
                <ReviewCard key={review.id} review={review} target={target} />
              )
            })
          ) : (
            <Text tag="p">
              {translator.trans(
                "account.review.index.emptyMessage",
                null,
                "pages",
              )}
            </Text>
          )}
        </div>
        <Pagination
          currentPageNumber={pagination.currentPageNumber}
          itemNumberPerPage={pagination.itemNumberPerPage}
          totalItemCount={pagination.totalItemCount}
          pageRange={2}
        />
      </div>
    </ProfilePage>
  )
}
